import { useState, useEffect } from 'react';
import {
  getModuleDetailsApi,
  traininglikeDislikeApi,
  markAsCompleteApi,
  markAsReadApi,
  getTrainingModulesListApi,
} from '../apiServices';
import { ModuleContentsLibrary, ModuleTitle, Shimmer, UserAssesmentDialog } from './';
import { toastFlashMessage } from '../../../utils';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import styles from '../../../assets/styles/training.module.scss';
import { NoResult } from '../../../shared_ui_components';
import { useLearningPathsStore } from './LearningPaths/LearningPaths.store';
import { useHandleSeconds } from 'features/onboarding/components/useHandleSeconds';
import ModuleAssessmentCardButton from '../assessment/ModuleBased/ModuleAssessmentCardButton';
import { useModuleAssessmentStore } from '../assessment/ModuleBased/ModuleAssessment.store';
import { useGetFF } from '@fstack-tech/ff_react_module';

export default function UserModuleDetailContainer(props) {
  const { role } = props;
  let location = useLocation();
  let history = useHistory();
  let params = useParams();
  const [state, setState] = useState({
    contents: [],
    activeContent: {},
  });
  const [module, setModule] = useState({});
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState(0);
  const { contents, activeContent } = state;
  const { setSeconds } = useHandleSeconds();
  const [userAssesmentDialog, setUserAssesmentDialog] = useState(false);
  const [moduleDetails, setModuleDetails] = useState([]);
  const { isEnabled: moduleAssessmentEnabled } = useGetFF({ flag_id: 'module_base_assessment' });

  const fetchModuleDetail = (activeContent = '') => {
    if (activeContent) {
      setState((prevState) => ({
        ...prevState,
        activeContent: activeContent,
      }));
    }
    getModuleDetailsApi(params.id).then((response) => {
      if (response.statusCode == 200) {
        if (!response?.data?.published_at) history.push('/training');
        if (!activeContent) {
          setState((prevState) => ({
            ...prevState,
            activeContent: response.data?.contents[0],
          }));
        }
        setState((prevState) => ({
          ...prevState,
          contents: response.data?.contents,
        }));
        setLoader(false);
        setModule(response.data);
      }
    });
  };
  const fetchTrainingModulesList = () => {
    setLoader((prevLoader) => ({
      ...prevLoader,
      modules: true,
    }));
    getTrainingModulesListApi().then((response) => {
      if (response.statusCode === 200) {
        setLoader((prevLoader) => ({
          ...prevLoader,
          training: false,
          modules: false,
        }));
        setModuleDetails(response.data);
      }
    });
  };
  const { setFetchFunctions } = useModuleAssessmentStore();
  useEffect(() => {
    // Save the functions to get modules in store for later use in module assessment modules
    setFetchFunctions({
      fetchTrainingModulesList,
    });
  }, [setFetchFunctions]);
  const handleChangeContent = (step) => {
    setState({
      ...state,
      activeContent: step,
    });
  };
  const updateActiveContent = (key, val) => {
    switch (key) {
      case 'comments':
        setState({
          ...state,
          activeContent: {
            ...state.activeContent,
            comments: val,
          },
          contents: state.contents.map((step) =>
            step.uuid === activeContent.uuid ? { ...state.activeContent, comments: val } : step
          ),
        });
        return true;
      case 'likeDislike':
        let activeContentUpdated = {
          ...state.activeContent,
          comments: state.activeContent.comments.map((comment) =>
            comment.id === val.id ? val : comment
          ),
        };
        setState({
          ...state,
          activeContent: activeContentUpdated,
          contents: state.contents.map((step) =>
            step.uuid === activeContent.uuid ? activeContentUpdated : step
          ),
        });
        return true;
      case 'delete':
        setState({
          ...state,
          activeContent: {
            ...state.activeContent,
            comments: state.activeContent.comments.filter(({ id }) => id !== val.id),
          },
          contents: state.contents.map((step) =>
            step.uuid === activeContent.uuid
              ? {
                  ...state.activeContent,
                  comments: state.activeContent.comments.filter(({ id }) => id !== val.id),
                }
              : step
          ),
        });
        return true;
      default:
        return false;
    }
  };
  const handleLikeDislike = (val) => {
    traininglikeDislikeApi(activeContent.uuid, { like: val }).then((response) => {
      if (response.statusCode === 200) {
        setState({
          ...state,
          activeContent: response.data ? response.data : activeContent,
        });
      } else {
        toastFlashMessage(response.message, 'error');
      }
    });
  };
  useEffect(() => {
    fetchModuleDetail();
  }, []);
  const handleMarkAsComplete = (contentType) => {
    let auxData = {};
    if (contentType === 1 && time === 0) auxData = { time_duration: 1 };
    else auxData = { time_duration: time };
    markAsCompleteApi(activeContent.uuid, auxData).then((response) => {
      if (response.statusCode == 200) {
        toastFlashMessage(response.message, 'success');
        fetchModuleDetail(response.data);
        setShowModal(false);
      } else {
        toastFlashMessage(response.message, 'error');
        setShowModal(false);
      }
    });
  };
  const { setSelectedRepLearningPathID: setLP } = useLearningPathsStore();
  const handleGoBack = () => {
    const id = location?.state?.rep_lp_id || '';
    if (id) setLP(id);

    if (location.state && location.state.prevPath) {
      history.push(location.state.prevPath);
    } else {
      history.push('/training');
    }
  };

  const handleMarkAsRead = (content) => {
    markAsReadApi(content.uuid).then((response) => {
      if (response.statusCode == 200) {
        setState({
          ...state,
          activeContent: response.data ? response.data : activeContent,
          contents: state.contents.map((step) =>
            step.uuid === activeContent.uuid ? response.data : step
          ),
        });
        props.setTime(0);
        setSeconds(content.uuid, 0);
      }
    });
  };

  return (
    <>
      {loader ? (
        <Shimmer type="ModuleCard" />
      ) : (
        <>
          <UserAssesmentDialog
            open={userAssesmentDialog}
            handleClose={() => setUserAssesmentDialog(false)}
            handleUserAssesment={setUserAssesmentDialog}
            moduleAssessmentId={module?.uuid}
            status={1}
            isFocusView={true}
          />
          <ModuleTitle module={module} isAdmin={false} handleGoBack={handleGoBack} />
          {/* <ModuleAssessmentCardButton
            isEnabled={moduleAssessmentEnabled}
            styles={styles}
            module={module}
            setUserAssesmentDialog={setUserAssesmentDialog}
            isRepView={true}
          /> */}
          {contents && contents.length ? (
            <ModuleContentsLibrary
              contents={contents}
              handleChangeContent={handleChangeContent}
              activeContent={activeContent}
              isAdmin={false}
              handleLikeDislike={handleLikeDislike}
              updateActiveContent={updateActiveContent}
              role={role}
              isPublished={module.published_at ? true : false}
              handleMarkAsComplete={handleMarkAsComplete}
              handleMarkAsRead={handleMarkAsRead}
              setShowModal={setShowModal}
              showModal={showModal}
              time={time}
              setTime={setTime}
              module={module}
            />
          ) : (
            <div className={styles.noStateWrapper}>
              <NoResult
                className="flexCentered"
                image={'no_content.svg'}
                title={
                  <p>
                    No content available in <span>{module.title}</span> Module
                  </p>
                }
              />
            </div>
          )}
        </>
      )}
    </>
  );
}
